import { useState, useCallback, } from 'react'

const useCriteria = ({
  label,
  inputRef,
  initialInputValue = '',
  initialSelectedValues = [],
  initialSuggestionValues = [],
  isWithMultipleSelection = false,
  onMultipleSelectionChange,
  isWithSuggestions = false,
  isWithAddButton = false,
}) => {
  let returnObject = {
    label,
    inputRef,
    isWithMultipleSelection,
    isWithSuggestions,
    isWithAddButton,
  }

  const [inputValue, setInputValue,] = useState(initialInputValue)
  returnObject = { ...returnObject, inputValue, setInputValue, }

  const [suggestionValues, setSuggestionValues,] = useState(
    initialSuggestionValues,
  )
  const [suggestionIsOpen, setSuggestionIsOpen,] = useState(false)

  if (isWithSuggestions)
    returnObject = {
      ...returnObject,
      suggestionValues,
      setSuggestionValues,
      suggestionIsOpen,
      setSuggestionIsOpen,
    }

  const [selectedValues, setSelectedValues,] = useState(initialSelectedValues)
  const onSelectChange = useCallback(
    event => {
      onMultipleSelectionChange({
        criteria: returnObject,
        ...event,
      })
    },
    [inputValue,],
  )
  if (isWithMultipleSelection)
    returnObject = {
      ...returnObject,
      selectedValues,
      setSelectedValues,
      onSelectChange,
    }

  return returnObject
}

export default useCriteria
